export default {
  appTitle: 'Registrierung | Wirecard',
  appHeader: {
    services: 'Dienstleistungen',
    company: 'Unternehmen',
    resources: 'Ressourcen'
  },
  appHead: {
    mainTitle: 'Jetzt Kreditkarten akzeptieren',
    subTitle: 'Registrieren Sie sich in nur wenigen Schritten und integrieren Sie Visa und Mastercard in Ihren Onlineshop',
    description: 'Bitte halten Sie eine digitale Kopie Ihres <strong>Personalausweises</strong>, Ihres <strong>Handelsregisterauszugs</strong> (nicht bei Einzelunternehmern/Freiberuflern) und einen Nachweis Ihrer aktuellen <strong>Geschäftsadresse</strong> bereit. Wir werden Sie im Verlauf Ihrer Registrierung bitten, diese Dokumente hochzuladen.'
  },
  aliasForm: {
    label: 'Bitte geben Sie Ihren Namen ein',
    button: 'Registrierung starten',
    invalid: 'Bitte geben Sie einen gültigen Namen an.'
  },
  paymentMethods: 'Verfügbare Zahlungsmethoden:',
  ecommerceSystems: 'Verfügbare E-Commerce-Systeme:',
  features: {
    title: 'Schnelle, sichere Zahlungsabwicklung und sofortige Auszahlungen',
    description: {
      p1: 'Kreditkarten zählen zu den beliebtesten Zahlungsmethoden im E-Commerce. ',
      p2: 'Mit Wirecard können Sie Visa und Mastercard ganz einfach in Ihren Shop integrieren.',
      p3: 'Bieten Sie Ihren Kunden eine bequeme und sichere Bezahlung und profitieren Sie von der sofortigen Verfügbarkeit Ihrer Einnahmen. Registrieren Sie sich jetzt in wenigen Minuten!'
    },
    feat1: 'Einfache und sichere Zahlungsabwicklung für Visa und Mastercard (mit 3D Secure)',
    feat2: 'Kontozugriff in Echtzeit und sofortige Auszahlungen',
    feat3: 'Intuitives Dashboard mit integrierten Analysefunktionen',
    feat4: 'Zusätzliche Zahlungsmethoden (demnächst verfügbar)',
    feat5: 'Verfügbar für Magento 2, PrestaShop and WooCommerce (nur Euro-Transaktionen möglich)'
  },
  video: {
    title: 'Übersichtliches Dashboard voller Funktionalität',
    description: 'Über das Dashboard können Sie Ihren Wirecard Account und sämtliche Transaktionen ganz einfach verwalten. Sehen Sie auf einen Blick alle Kontoaktivitäten und greifen Sie auf eine Vielzahl von Analysen und Reportings zu, die Ihnen dabei helfen, Ihr Business zu optimieren. Einen detaillierten Überblick über das Dashboard und alle Features erhalten Sie in unserem Tutorial.',
    button: 'Jetzt Tutorial abspielen'
  },
  references: {
    title: 'Referenzen',
    ref1: {
      content: '„Ein reibungsloser Zahlungsverkehr ist für unsere Plattform das A und O. Auf Wirecard können wir uns 100 % verlassen.“',
      role: 'Gründer und Geschäftsführer'
    },
    ref2: {
      content: '„Wir waren auf der Suche nach einer Lösung, die sich einfach in unseren Shop integrieren lässt und sich in der Zukunft flexibel anpassen lässt.“',
      role: 'Gründer und CEO'
    },
    ref3: {
      content: '„Mit Wirecard können wir Kreditkartenzahlungen unserer Kunden schnell und sicher abwickeln. Alle Einnahmen sind nach der Zahlung direkt verfügbar.“',
      role: 'Geschäftsführer'
    }
  },
  footer: {
    aboutTitle: 'Digitize now',
    aboutDescription: 'Wirecard ist eine der weltweit am schnellsten wachsenden digitalen Plattformen im Bereich Financial Commerce. Wir bieten unseren Kunden ein ständig wachsendes Ökosystem an Mehrwertdiensten rund um den digitalen Zahlungsverkehr: online, mobile und am Point of Sale.',
    aboutButton: 'Jetzt Kontakt aufnehmen',
    follow: 'Folgen Sie uns',
    menu: {
      company: 'Unternehmen',
      benefits: 'Leistungen',
      products: 'Produkte',
      marketing: 'Marketing Intelligence',
      investor: 'Investor Relations',
      newsroom: 'Newsroom',
      careers: 'Karriere'
    },
    newsletter: {
      title: 'Melden Sie sich für unseren Newsletter an und erfahren Sie regelmäßig von Wirecard Lösungen und Branchennews.',
      input: 'Ihre E-Mail-Adresse...',
      terms: 'Ich bin damit einverstanden, dass Sie mir weitere Informationen gemäß den {0} zukommen lassen. Diese Einwilligung kann ich jederzeit widerrufen, ohne dass mir hierdurch Nachteile jeglicher Art entstehen.',
      pp: 'Datenschutzbestimmungen'
    },
    labs: 'Wirecard Labs',
    subMenu: {
      legal: 'Impressum',
      privacy: 'Datenschutz'
    }
  }
}
